import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";
import { scrollToTop } from "@/src/lib/utils";
import { RoutesType } from "@/src/routes";
import useAdmin from "@/src/hooks/useAdmin";
import useSuperAdmin from "@/src/hooks/useSuperAdmin";
import useCoinLogsAccess from "@/src/hooks/useCoinLogsAccess";

const useRouteLogic = () => {
  const location = useLocation();
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };
  return { activeRoute };
};

const useColorModes = () => {
  const activeColor = useColorModeValue("gray.700", "white");
  const inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600",
  );
  const activeIcon = useColorModeValue("brand.500", "white");
  const textColor = useColorModeValue("secondaryGray.500", "white");
  const brandColor = useColorModeValue("brand.500", "brand.400");
  return { activeColor, inactiveColor, activeIcon, textColor, brandColor };
};

const MainLink: React.FC<{ route: RoutesType }> = ({ route }) => {
  const { activeRoute } = useRouteLogic();
  const { activeColor, textColor, activeIcon, brandColor } = useColorModes();

  if (route.layout !== "/") return null;

  return (
    <Box>
      <NavLink to={route.path} onClick={() => scrollToTop()}>
        <Box>
          <HStack
            spacing={activeRoute(route.path.toLowerCase()) ? "22px" : "26px"}
            py="5px"
            ps="10px"
          >
            <Flex w="100%" alignItems="center" justifyContent="center">
              {route.icon && (
                <Box
                  color={
                    activeRoute(route.path.toLowerCase())
                      ? activeIcon
                      : textColor
                  }
                  me="18px"
                >
                  {route.icon}
                </Box>
              )}
              <Text
                style={{ marginTop: -4 }}
                me="auto"
                color={
                  activeRoute(route.path.toLowerCase())
                    ? activeColor
                    : textColor
                }
                fontWeight={
                  activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                }
              >
                {route.name}
              </Text>
            </Flex>
            <Box
              h="36px"
              w="4px"
              bg={
                activeRoute(route.path.toLowerCase())
                  ? brandColor
                  : "transparent"
              }
              borderRadius="5px"
            />
          </HStack>
        </Box>
      </NavLink>
    </Box>
  );
};

export function SidebarLinks(props: { routes: RoutesType[] }) {
  const { routes } = props;
  const isAdmin = useAdmin();
  const isSuperAdmin = useSuperAdmin();
  const hasCoinLogsAccess = useCoinLogsAccess();

  return (
    <>
      {routes
        .filter((route) => {
          if (
            route.path === "/on-hold-payouts" ||
            route.path === "/bulk-add-coins"
          ) {
            return isSuperAdmin;
          }

          if (route.path === "/coin-logs") {
            return hasCoinLogsAccess;
          }

          if (
            route.path === "/account-managers" ||
            route.path === "/social-media-posts"
          ) {
            return isAdmin;
          }
          return true;
        })
        .map((route, index) => (
          <MainLink key={index} route={route} />
        ))}
    </>
  );
}

export default SidebarLinks;
